export const inspirationalQuotes = [
  {
    quote: "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work.",
    author: "Steve Jobs"
  },
  {
    quote: "The way to get started is to quit talking and begin doing.",
    author: "Walt Disney"
  },
  {
    quote: "Innovation distinguishes between a leader and a follower.",
    author: "Steve Jobs"
  },
  {
    quote: "Success is not final, failure is not fatal: it is the courage to continue that counts.",
    author: "Winston Churchill"
  },
  {
    quote: "The future belongs to those who believe in the beauty of their dreams.",
    author: "Eleanor Roosevelt"
  },
  {
    quote: "It is during our darkest moments that we must focus to see the light.",
    author: "Aristotle"
  },
  {
    quote: "Success is walking from failure to failure with no loss of enthusiasm.",
    author: "Winston Churchill"
  },
  {
    quote: "The only impossible journey is the one you never begin.",
    author: "Tony Robbins"
  },
  {
    quote: "In the middle of difficulty lies opportunity.",
    author: "Albert Einstein"
  },
  {
    quote: "Believe you can and you're halfway there.",
    author: "Theodore Roosevelt"
  },
  {
    quote: "The best time to plant a tree was 20 years ago. The second best time is now.",
    author: "Chinese Proverb"
  },
  {
    quote: "Don't be afraid to give up the good to go for the great.",
    author: "John D. Rockefeller"
  },
  {
    quote: "The way to get things done is not to mind who gets the credit for doing them.",
    author: "Benjamin Jowett"
  },
  {
    quote: "If you want to achieve greatness stop asking for permission.",
    author: "Anonymous"
  },
  {
    quote: "Things work out best for those who make the best of how things work out.",
    author: "John Wooden"
  },
  {
    quote: "To live a creative life, we must lose our fear of being wrong.",
    author: "Joseph Chilton Pearce"
  },
  {
    quote: "If you are not willing to risk the usual you will have to settle for the ordinary.",
    author: "Jim Rohn"
  },
  {
    quote: "Trust because you are willing to accept the risk, not because it's safe or certain.",
    author: "Anonymous"
  },
  {
    quote: "Take up one idea. Make that one idea your life - think of it, dream of it, live on that idea.",
    author: "Swami Vivekananda"
  },
  {
    quote: "All our dreams can come true if we have the courage to pursue them.",
    author: "Walt Disney"
  },
  {
    quote: "Good things happen to those who hustle.",
    author: "Anais Nin"
  },
  {
    quote: "Whatever you do, do it well.",
    author: "Walt Disney"
  },
  {
    quote: "Don't be afraid to give up the good to go for the great.",
    author: "John D. Rockefeller"
  },
  {
    quote: "What we think, we become.",
    author: "Buddha"
  },
  {
    quote: "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do.",
    author: "Mark Twain"
  },
  {
    quote: "Life is 10% what happens to you and 90% how you react to it.",
    author: "Charles R. Swindoll"
  },
  {
    quote: "The most difficult thing is the decision to act, the rest is merely tenacity.",
    author: "Amelia Earhart"
  },
  {
    quote: "Every strike brings me closer to the next home run.",
    author: "Babe Ruth"
  },
  {
    quote: "Definiteness of purpose is the starting point of all achievement.",
    author: "W. Clement Stone"
  },
  {
    quote: "Life isn't about getting and having, it's about giving and being.",
    author: "Kevin Kruse"
  },
  {
    quote: "We become what we think about.",
    author: "Earl Nightingale"
  },
  {
    quote: "When you cease to dream you cease to live.",
    author: "Malcolm Forbes"
  },
  {
    quote: "A person who never made a mistake never tried anything new.",
    author: "Albert Einstein"
  },
  {
    quote: "The person who says it cannot be done should not interrupt the person who is doing it.",
    author: "Chinese Proverb"
  },
  {
    quote: "There are no traffic jams along the extra mile.",
    author: "Roger Staubach"
  },
  {
    quote: "It is never too late to be what you might have been.",
    author: "George Eliot"
  },
  {
    quote: "You become what you believe.",
    author: "Oprah Winfrey"
  },
  {
    quote: "I would rather die of passion than of boredom.",
    author: "Vincent van Gogh"
  },
  {
    quote: "A truly rich man is one whose children run into his arms when his hands are empty.",
    author: "Anonymous"
  },
  {
    quote: "It is not what you do for your children, but what you have taught them to do for themselves.",
    author: "Ann Landers"
  },
  {
    quote: "If you want your children to turn out well, spend twice as much time with them, and half as much money.",
    author: "Abigail Van Buren"
  },
  {
    quote: "Build your own dreams, or someone else will hire you to build theirs.",
    author: "Farrah Gray"
  },
  {
    quote: "The battles that count aren't the ones for gold medals. The struggles within yourself are.",
    author: "Jesse Owens"
  },
  {
    quote: "Education costs money. But then so does ignorance.",
    author: "Sir Claus Moser"
  },
  {
    quote: "I have learned over the years that when one's mind is made up, this diminishes fear.",
    author: "Rosa Parks"
  },
  {
    quote: "It does not matter how slowly you go as long as you do not stop.",
    author: "Confucius"
  },
  {
    quote: "If you look at what you have in life, you'll always have more.",
    author: "Oprah Winfrey"
  },
  {
    quote: "Remember that not getting what you want is sometimes a wonderful stroke of luck.",
    author: "Dalai Lama"
  },
  {
    quote: "You can't use up creativity. The more you use, the more you have.",
    author: "Maya Angelou"
  },
  {
    quote: "Dream big and dare to fail.",
    author: "Norman Vaughan"
  },
  {
    quote: "Our lives begin to end the day we become silent about things that matter.",
    author: "Martin Luther King Jr."
  }
];

// Function to get a random quote
export const getRandomQuote = () => {
  const randomIndex = Math.floor(Math.random() * inspirationalQuotes.length);
  return inspirationalQuotes[randomIndex];
};